module.exports = __webpack_public_path__ + "img/step1.c8810a09.png";